const PHYSICAL_STORE_SUFFIX = /\s*\(physical store\)\s*$/i;

export function getGiftCardPaymentLink(giftCardCode: string) {
  // Payment responses append this display label; Blackhawk stores only the code.
  const isPhysicalCard = PHYSICAL_STORE_SUFFIX.test(giftCardCode);
  const code = isPhysicalCard ? giftCardCode.replace(PHYSICAL_STORE_SUFFIX, '') : giftCardCode;
  const path = isPhysicalCard ? '/marketing/blackhawk-gift-card-logs' : '/marketing/gift-cards';

  return { isPhysicalCard, link: `${path}?code=${encodeURIComponent(code)}` };
}
